(function ($) {
    $(function () {

        let promotionResizeTimer;

        function setupPromotionWrappers() {
            const promotionBlocks = $(".block-promotion-card");

            if (!promotionBlocks.length) {
                return;
            }

            const isMobile = window.matchMedia("(max-width: 575.98px)").matches;

            promotionBlocks.each(function () {
                const wrapper = $(this).find(".promotion-wrapper").first();

                if (!wrapper.length) {
                    return;
                }

                const desktopImage = wrapper.attr("data-background-desktop");
                const mobileImage = wrapper.attr("data-background-mobile");

                const imageUrl = isMobile
                    ? mobileImage || desktopImage
                    : desktopImage || mobileImage;

                if (!imageUrl) {
                    wrapper.css({
                        "background-image": "",
                        "min-height": ""
                    });

                    return;
                }

                // Apply the selected background image
                wrapper.css("--promotion-background-image", `url("${imageUrl}")`);

                // Load the image so its natural dimensions can be measured
                const image = new Image();

                image.onload = function () {
                    const wrapperWidth = wrapper.outerWidth();

                    if (!wrapperWidth || !image.naturalWidth || !image.naturalHeight) {
                        return;
                    }

                    const calculatedHeight =
                        wrapperWidth * (image.naturalHeight / image.naturalWidth);

                    wrapper.css("min-height", `${calculatedHeight}px`);
                };

                image.src = imageUrl;
            });
        }

        $(window).on("load resize", function () {
            clearTimeout(promotionResizeTimer);

            promotionResizeTimer = setTimeout(function () {
                setupPromotionWrappers();
            }, 100);
        });


    });
})(jQuery);
